export const PAGE_REVEAL_DELAY = 0.72;
export const PAGE_REVEAL_EASE = [0.22, 1, 0.36, 1];
export const PAGE_REVEAL_DURATION = 0.55;

export const PAGE_FADE_UP = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: PAGE_REVEAL_DURATION,
      ease: PAGE_REVEAL_EASE,
    },
  },
};
